/* import Vue from "vue"; */
import {App as StdApp} from "@std/app";
/*
import VueJsApp from "@main/vue/AppJs";
import VueTsApp from "@main/vue/AppTs"; */

export class App extends StdApp {
    constructor(config = {}) {
        super(config);
    }

    run() {
        /* eslint-disable no-new */
        /*  new Vue({
            el: "#vue-js-app",
            // eslint-disable-next-line
            render: h => h(VueJsApp)
        }); */

    }
}


import "@main/helpers/device";
import "@main/components/sliders";
import "@main/components/select-dropdown";
import "@main/components/input-file";
import "@main/components/change-language";
import "@main/components/layouts";
import "@main/components/video"
import "@main/components/modal"
import "@main/components/show-more"
import "@main/components/forms"
import "@main/components/masked-input"
import "@main/components/leaflet"
import "@main/components/toggle-sections"
import "@main/components/toggle-subsections"
import "@main/components/toggle-download"
import "@main/components/toggle-description"
import "@main/components/filter"
import "@main/components/video-tabs"
import "@main/components/yt-player"
import "@main/components/elementsEditor"
import "@main/components/table-container"
import "@main/components/filter/submit"

import "@main/behaviors/page-comparison"
